import { css } from 'styled-components';

// Utilitaire CSS pour garantir un contraste suffisant sur tous les appareils
export const enhancedTextContrast = css`
  color: #000000 !important; /* Forcer la couleur noire pour garantir la visibilité */
  text-shadow: 0 0 1px rgba(255,255,255,0.5); /* Ajouter un léger contour pour améliorer la lisibilité */
  font-weight: 500; /* Rendre le texte légèrement plus gras */
`;

// Utilitaire CSS pour les titres avec contraste amélioré
export const enhancedHeadingContrast = css`
  ${enhancedTextContrast}
  font-weight: 600; /* Titres un peu plus gras */
`;

// Utilitaire CSS pour les boutons avec contraste amélioré
export const enhancedButtonContrast = css`
  ${enhancedTextContrast}
  font-weight: bold; /* Boutons en gras */
`;

// Détection des appareils Samsung (à utiliser avec précaution)
export const isSamsungDevice = (): boolean => {
  if (typeof navigator !== 'undefined') {
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.includes('samsung') || userAgent.includes('sm-') || userAgent.includes('gt-');
  }
  return false;
};

// Hook pour appliquer conditionnellement des styles de contraste amélioré
export const getConditionalContrastStyle = () => {
  // On pourrait implémenter une logique plus sophistiquée ici
  // Pour l'instant, on applique toujours les styles pour garantir la compatibilité
  return true;
};

